module.exports = __webpack_public_path__ + "img/医疗装备行业数字化转型场景图谱.ae4484f9.jpg";